module.exports = __webpack_public_path__ + "img/UBT.0f5231e5.png";